import React, { useState } from 'react';
import { useCurrentEditor } from '@tiptap/react';

import TextHighlightIcon from '../../../../icons/editor/TextHighlightIcon';

import PopoverColorPicker, { WHITE } from './PopoverColorPicker';

const HighlightComponent: React.FC = () => {
  const { editor } = useCurrentEditor();
  const [color, setColor] = useState('');

  const toggleHighlight = (hexColor: string) => {
    if (hexColor === WHITE) {
      // White is the "no highlight" choice here: unset rather than wrapping the text in a redundant white <mark>
      editor?.chain().focus().unsetHighlight().run();
    } else {
      editor?.chain().focus().toggleHighlight({ color: hexColor }).run();
    }
    setColor(hexColor);
  };

  if (!editor) {
    return null;
  }

  return (
    <PopoverColorPicker
      onChange={toggleHighlight}
      isEnabledFunc={() => !!editor?.can().toggleHighlight({ color })}
      icon={<TextHighlightIcon />}
      label="Highlight color"
    />
  );
};

export default HighlightComponent;
